import { FC } from 'react';

import useWindowSize from '@editor/hooks/useWindowSize';
import { Dialog } from '@repo/ui-kit/components/core/Dialog';

import VerifyEmailOtp from './VerifyEmailOtp';

type VerifyEmailOtpDialogProps = {
  isOpen: boolean;
};

const OTP_DIALOG_WIDTH = {
  mobile: '442px',
  desktop: '816px',
} as const;

const OTP_DIALOG_HEIGHT = {
  tablet: '100vh',
  desktop: '605px',
} as const;

export const VerifyEmailOtpDialog: FC<VerifyEmailOtpDialogProps> = ({
  isOpen,
}) => {
  const { isMobile, isTabletMin } = useWindowSize();
  const dialogHeight = isTabletMin
    ? OTP_DIALOG_HEIGHT.tablet
    : OTP_DIALOG_HEIGHT.desktop;
  const dialogWidth = isMobile
    ? OTP_DIALOG_WIDTH.mobile
    : OTP_DIALOG_WIDTH.desktop;

  return (
    <Dialog.Root modal open={isOpen}>
      <Dialog.Content
        height={dialogHeight}
        showCloseButton={false}
        title="Verify your email"
        width={dialogWidth}
      >
        <VerifyEmailOtp />
      </Dialog.Content>
    </Dialog.Root>
  );
};
